module.exports = __webpack_public_path__ + "static/media/k.81726dcb.ogg";